import { render, staticRenderFns } from "./ListUsersRating.vue?vue&type=template&id=cb02e0f2"
import script from "./ListUsersRating.vue?vue&type=script&lang=js"
export * from "./ListUsersRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports